// https://bitbucket.hotterpads.com/projects/RP/repos/rpjava/browse/app/capps/client/src/main/java/com/hotpads/capps/client/enums/statuscallback/IdVerificationStatusEnum.java
export enum IDVerificationStatus {
  CURRENTLY_IDENTIFIED = 'CURRENTLY_IDENTIFIED',
  FROZEN = 'FROZEN',
  LOCKED_OUT_NOT_IDENTIFIED = 'LOCKED_OUT_NOT_IDENTIFIED',
  LOCKED_OUT_PREVIOUSLY_IDENTIFIED = 'LOCKED_OUT_PREVIOUSLY_IDENTIFIED',
  LOCKED_OUT_REAUTHENTICATING = 'LOCKED_OUT_REAUTHENTICATING',
  NOT_IDENTIFIED = 'NOT_IDENTIFIED',
  PREVIOUSLY_IDENTIFIED = 'PREVIOUSLY_IDENTIFIED',
  REAUTHENTICATING = 'REAUTHENTICATING',
  THIN_FILE = 'THIN_FILE',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
}
